import { Outlet } from "react-router-dom";
import ContactBar from "@/components/feature/ContactBar";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import FloatingCallCta from "@/components/feature/FloatingCallCta";

export default function Layout() {
  return (
    <div className="font-roboto min-h-screen flex flex-col">
      <ContactBar />
      <Navbar />
      <main className="flex-1 pt-28">
        <Outlet />
      </main>
      <Footer />
      <FloatingCallCta />
    </div>
  );
}